<script>
import {api} from "@/modules/api";
import ProductBox from "@/components/products/ProductBox.vue";

export default {
  name: 'OtherProduct',
  components: {ProductBox},
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      products: {}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.products = await api.products.getSimilaryProducts(this.category.id)
    }
  }
}
</script>

<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 lg:px-6 mx-auto max-w-screen-xl lg:py-16 ">
      <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
          Produits similaires
        </h2>
        <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">
          Découvrez nos autres produits dans la gamme {{ category.Label }}
        </p>
      </div>
      <div v-if="products" class="flex overflow-x-scroll lg:overflow-visible lg:grid lg:gap-8 mb-6 lg:mb-16 lg:grid-cols-4">
          <product-box v-for="(product, index) in products" :key="index" :product="product" />
      </div>
    </div>
  </section>
</template>
